/** A brand-new account has no quotes, coverage or claims yet — only an application to start. */
const NEW_ACCOUNT_TARGET = '/application'
// Any origin that cannot be ours, so a resolved URL still on it must be a path.
const SENTINEL_ORIGIN = 'https://redirect.invalid'

/**
 * The destination a `/sign-up` visit carries, ignoring anything off-origin.
 *
 * The marketing home and `/insure` aren't pages anyone was headed for, so a new account
 * from either starts the application — whatever the account's staff flag, which `/insure`
 * would otherwise route to the Console. Compared on pathname alone, since every
 * marketing link carries `?utm_source=...`.
 */
export function signUpRedirectTarget(redirectUrl: string | null | undefined): string {
  if (!redirectUrl?.startsWith('/')) return NEW_ACCOUNT_TARGET
  // Resolve, don't pattern-match: the parser strips tabs, so `/<tab>/host` becomes `//host`.
  const resolved = new URL(redirectUrl, SENTINEL_ORIGIN)
  if (resolved.origin !== SENTINEL_ORIGIN) return NEW_ACCOUNT_TARGET
  if (resolved.pathname === '/' || resolved.pathname === '/insure') return NEW_ACCOUNT_TARGET
  return resolved.pathname + resolved.search + resolved.hash
}
